import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/u662895325/domains/onixdigital.pro/hbuilds/source/repository/node_modules/next/dist/client/app-dir/link.js");
